import api from '@api';
import {
    IGetCouponsData,
    IGetCouponsDataFormatted,
    IGetCouponsThemesDataFormatted,
    IGetCouponsTypesDataFormatted,
    IGetLinkReductionData,
    IGetOffersDataFormatted,
} from '@api/types';
import { ICreateUseRequestInfiniteResponse } from '@apiHooks';
import { ICouponFiltersValues } from '@pages/coupons/interfaces';
import { LIMIT } from './config';

export const getKey = (
    index: number,
    previousPageData: unknown[],
    filters: ICouponFiltersValues,
    ...dependencies: unknown[]
): unknown[] => {
    if (previousPageData && !previousPageData.length) return null;

    const offset = LIMIT * index;

    return [`couponsKey-${offset}`, offset, filters, ...dependencies];
};

export const prepareSelectOptions = <
    T extends
        | IGetCouponsThemesDataFormatted
        | IGetCouponsTypesDataFormatted
        | IGetOffersDataFormatted,
    K extends keyof T
>(
    array: T[],
    labelProperty: K,
): { label: T[K]; value: T['id'] }[] =>
    array.map((item: T) => ({
        value: item.id,
        label: item[labelProperty],
    }));

export const collectObjectWithIds = <
    T extends
        | IGetCouponsThemesDataFormatted
        | IGetCouponsTypesDataFormatted
        | IGetOffersDataFormatted,
    K extends keyof T
>(
    array: T[],
    property: K,
): Record<T['id'], T[K]> =>
    array.reduce(
        (acc: Record<T['id'], T[K]>, current) => ({
            ...acc,
            [current.id]: current[property],
        }),
        {} as Record<T['id'], T[K]>, // TODO replace "as" with "satisfies" once TS is upgraded
    );
export const formatCoupons = ({
    id,
    attributes: {
        code: promocode,
        isPersonal,
        userId,
        offerId,
        dateFrom,
        dateTo,
        typeId,
        url,
        name,
        description,
    },
}: IGetCouponsData): IGetCouponsDataFormatted => ({
    id,
    promocode,
    isPersonal: !!isPersonal,
    dateFrom,
    dateTo,
    title: name,
    description,
    typeId,
    userId,
    offerId,
    url,
});

export const addParamsToDeeplink = (link: string, couponLink: string): string => {
    try {
        const url: URL = new URL(link);
        url.searchParams.append('to', couponLink);
        url.searchParams.append('material', 'wm-coupon');
        return url.toString();
    } catch (error) {
        console.error(error);
        return link;
    }
};

export const reduceLink = async (url: string): Promise<string> => {
    const { data: reducedLinkData } = (await api.linkReduction.reduceLink({
        body: { urlContainer: url },
    })) as ICreateUseRequestInfiniteResponse<IGetLinkReductionData>;

    const firstReducedLinkInfo = reducedLinkData?.attributes;
    const reducedLink = firstReducedLinkInfo[0]?.result || null;

    return reducedLink;
};
